import { createAction } from '@reduxjs/toolkit';

const decrementCount = createAction('collections/decrementCount');

export default decrementCount;
